// @core/api/endpoints/subscription/validate_discount.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidateDiscountRequest,
  ValidateDiscountResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Validate discount code
 * Checks if a discount code is valid for a specific plan and tenant. Returns the calculated discount amount without applying it.
 * @public This endpoint does not require authentication
 */
export async function ValidateDiscount(
  data: ValidateDiscountRequest,
  options?: RequestOptions
): Promise<ValidateDiscountResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/discounts/validate`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<ValidateDiscountResponse>(requestPath, data, requestOptions);
}
